import React from "react";

const PosterSlider = () => {
  return <div>PosterSlider</div>;
};

export default PosterSlider;
